module.exports = __webpack_public_path__ + "img/empty.2396af8a.png";